import { Modal, ModalHeader, ModalBody, ModalHeaderWithActions } from "@evertrue/et-components";
import PropTypes from "prop-types";

const ThankviewModal = ({
  isOpen,
  closeModal,
  children,
  title,
  withActions,
  onSubmit,
  submitLabel,
  closeLabel,
  size,
  disableSubmit = false,
  width,
  height,
}) => {
  return (
    <>
      <Modal className="center-modal" isOpen={isOpen} closeModal={closeModal} closeOnOutsideClick={true} size={size}>
        {withActions && (
          <ModalHeaderWithActions
            submitLabel={submitLabel}
            onSubmit={onSubmit}
            title={title}
            closeLabel={closeLabel}
            closeModal={closeModal}
            disableSubmit={disableSubmit}
          />
        )}
        {!withActions && <ModalHeader title={title} closeModal={closeModal} />}
        <ModalBody>
          <div style={{ width: { width }, height: { height } }}>{children}</div>
        </ModalBody>
      </Modal>
    </>
  );
};

ThankviewModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.string,
  withActions: PropTypes.bool,
  onSubmit: PropTypes.func,
  submitLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["small", "medium", "large", "default", "fullscreen"]),
    PropTypes.string,
  ]),
  disableSubmit: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default ThankviewModal;
